/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BillingFrequency } from './BillingFrequency';
import {
    BillingFrequencyFromJSON,
    BillingFrequencyFromJSONTyped,
    BillingFrequencyToJSON,
} from './BillingFrequency';
import type { WebApiModelsEnumerationTypesMembershipProductType } from './WebApiModelsEnumerationTypesMembershipProductType';
import {
    WebApiModelsEnumerationTypesMembershipProductTypeFromJSON,
    WebApiModelsEnumerationTypesMembershipProductTypeFromJSONTyped,
    WebApiModelsEnumerationTypesMembershipProductTypeToJSON,
} from './WebApiModelsEnumerationTypesMembershipProductType';

/**
 * 
 * @export
 * @interface WebApiMembershipProductDtoCreateMembershipProductDto
 */
export interface WebApiMembershipProductDtoCreateMembershipProductDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiMembershipProductDtoCreateMembershipProductDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WebApiMembershipProductDtoCreateMembershipProductDto
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMembershipProductDtoCreateMembershipProductDto
     */
    price: number;
    /**
     * 
     * @type {BillingFrequency}
     * @memberof WebApiMembershipProductDtoCreateMembershipProductDto
     */
    billingFrequency: BillingFrequency;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMembershipProductType}
     * @memberof WebApiMembershipProductDtoCreateMembershipProductDto
     */
    membershipProductType: WebApiModelsEnumerationTypesMembershipProductType;
    /**
     * 
     * @type {number}
     * @memberof WebApiMembershipProductDtoCreateMembershipProductDto
     */
    sortOrder?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiMembershipProductDtoCreateMembershipProductDto
     */
    visiblePublic?: boolean | null;
}

/**
 * Check if a given object implements the WebApiMembershipProductDtoCreateMembershipProductDto interface.
 */
export function instanceOfWebApiMembershipProductDtoCreateMembershipProductDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "billingFrequency" in value;
    isInstance = isInstance && "membershipProductType" in value;

    return isInstance;
}

export function WebApiMembershipProductDtoCreateMembershipProductDtoFromJSON(json: any): WebApiMembershipProductDtoCreateMembershipProductDto {
    return WebApiMembershipProductDtoCreateMembershipProductDtoFromJSONTyped(json, false);
}

export function WebApiMembershipProductDtoCreateMembershipProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMembershipProductDtoCreateMembershipProductDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'price': json['price'],
        'billingFrequency': BillingFrequencyFromJSON(json['billingFrequency']),
        'membershipProductType': WebApiModelsEnumerationTypesMembershipProductTypeFromJSON(json['membershipProductType']),
        'sortOrder': !exists(json, 'sortOrder') ? undefined : json['sortOrder'],
        'visiblePublic': !exists(json, 'visiblePublic') ? undefined : json['visiblePublic'],
    };
}

export function WebApiMembershipProductDtoCreateMembershipProductDtoToJSON(value?: WebApiMembershipProductDtoCreateMembershipProductDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'price': value.price,
        'billingFrequency': BillingFrequencyToJSON(value.billingFrequency),
        'membershipProductType': WebApiModelsEnumerationTypesMembershipProductTypeToJSON(value.membershipProductType),
        'sortOrder': value.sortOrder,
        'visiblePublic': value.visiblePublic,
    };
}

